const baseURL = "https://wavemec.com";
console.log('baseURL: ' + baseURL)
export { baseURL };

